export default "__VITE_ASSET__BIcOR2Na__"